import React, { useEffect, useState } from 'react'
import Api from 'services/api'

type Props = {
  id:number
}

const DealerAggregates = ({ id }: Props) => {
  const [dealerRelationsCount, setDealerRelationsCount] = useState({
    archivedDevicesCount: 0,
    customersCount: 0,
    devicesCount: 0,
    unassignedCount: 0,
    featureCodesCount: 0,
    notificationRecipientsCount: 0
  })

  useEffect(() => {
    id &&
      Api.Dealers.get(id)
        .then(({ customersCount, devicesCount, unassignedCount, archivedDevicesCount, notificationRecipientsCount, featureCodesCount }) => {
          setDealerRelationsCount({ customersCount, devicesCount, unassignedCount, archivedDevicesCount, notificationRecipientsCount, featureCodesCount })
        })
  }, [id])

  const {
    customersCount,
    devicesCount,
    unassignedCount,
    archivedDevicesCount,
    notificationRecipientsCount,
    featureCodesCount
  } = dealerRelationsCount

  return (
    <>
      <div>{customersCount} Customers</div>
      <div>{devicesCount} Devices</div>
      <div>{unassignedCount} Unassigned Devices</div>
      <div>{featureCodesCount} Feature codes</div>
      <div>{notificationRecipientsCount} Notification Recipients</div>
      <div>{archivedDevicesCount} Archived Devices</div>
    </>
  )
}

export default DealerAggregates
